import PubSub from "pubsub-js";

var CodeEmbed = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-CodeEmbed',
	};

	$.extend(true, this.options, options);

};

CodeEmbed.prototype.init = function() {

	var self = this;

	self.$wrapper = self.options.$el.find(`.${self.options.baseClass}__embed`);
	self.$iframe = self.options.$el.find('iframe');

	self.sizeIFrame();

};

CodeEmbed.prototype.sizeIFrame = function() {

	var self = this;

	let padding = 56.25;

	if (self.$iframe.length) {

		let width = self.$iframe.attr('width');
		let height = self.$iframe.attr('height');

		if (width && height) {
			padding = (height / width) * 100;
		}
	
		self.$iframe.attr('width', '');
		self.$iframe.attr('height', '');

	}

	self.$wrapper.css('padding-bottom', padding+'%');

};

export default CodeEmbed;
